import React from "react";
import Styles from "./Login.module.css";
import LoginCompo from "../components/login/LoginCompo";

function Login() {
	return (
		<div>
			<LoginCompo />
		</div>
	);
}

export default Login;
